/* eslint-disable import/no-unresolved */
import {
  useIntl as useIntlOriginal,
  FormattedMessage as FormattedMessageOriginal,
  /* @ts-expect-error: react-intl-original is aliased in vite.config.ts */
} from 'react-intl-original';

import { getDevToolsLocalItem } from '@main/utils/devTools';
/* @ts-expect-error: react-intl-original is aliased in vite.config.ts */
export * from 'react-intl-original';

/**
 * This is only used by development and preview environment.
 * It allows the devtools to show ids instead of the text by flipping
 * a toggle in the devtools
 */
const useIntl = () => {
  const intl = useIntlOriginal();
  if (
    getDevToolsLocalItem({
      key: 'devtoolsContinuousUpdate',
    })?.general.showIds
  ) {
    return {
      ...intl,
      formatMessage: ({ id }: { id: string }) => id,
    };
  }
  return intl;
};

const FormattedMessage = (props: { id: string }) => {
  if (
    getDevToolsLocalItem({
      key: 'devtoolsContinuousUpdate',
    })?.general.showIds
  ) {
    return props.id;
  }

  return <FormattedMessageOriginal {...props} />;
};

export { useIntl, FormattedMessage };
